import { render, staticRenderFns } from "./SujetDetails.vue?vue&type=template&id=662ab163&scoped=true&"
import script from "./SujetDetails.vue?vue&type=script&lang=js&"
export * from "./SujetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ab163",
  null
  
)

export default component.exports